module.exports = __webpack_public_path__ + "img/search.7712eab6.svg";